import { useState } from "react";
import Papa from "papaparse";
import { db } from "./firebase";
import { collection, addDoc } from "firebase/firestore";
import { getAuth } from "firebase/auth";

export default function UploadTransactions() {
  const [parsedRows, setParsedRows] = useState([]);
  const [statusMessage, setStatusMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const user = getAuth().currentUser;
  const [defaultAccount, setDefaultAccount] = useState("");
  const [loading, setLoading] = useState(false);
  const [flipped, setFlipped] = useState(false);

  const handleFlipAmounts = () => {
    const flippedRows = parsedRows.map(row => {
      const amount = parseFloat(row.Amount || 0);
      return {
        ...row,
        Amount: (amount * -1).toFixed(2)
      };
    });
    setParsedRows(flippedRows);
    setFlipped(!flipped);
  };

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      complete: function(results) {
        console.log("Parsed result:", results.data);
        setParsedRows(results.data);
      }
    });
  };

  const handleSave = async () => {
    if (!user) {
      setErrorMessage("You must be signed in to upload transactions.");
      return;
    }

    // ✅ Validate required fields
    for (const row of parsedRows) {
      if (!row.Amount || !row.Date) {
        setErrorMessage("Missing Amount or Date in one or more rows. Please check your CSV.");
        return;
      }
    }

    try {
      setLoading(true); // ✅ Start spinner

        for (const row of parsedRows) {
        const tx = {
        userId: user.uid,
        amount: parseFloat(row.Amount),
        date: new Date(row.Date),
        vendor: row.Description || row.Vendor || "",
        source: "manual-upload",
        status: "needs-review",
        category: row.Category ? [row.Category] : [],
        accountId: row.Account || row["Account Name"] || defaultAccount || ""
        };
        await addDoc(collection(db, "transactions"), tx);
      }
      setStatusMessage("✅ Transactions uploaded successfully!");
      setParsedRows([]);

      // Auto-close the message after 5 seconds
      setTimeout(() => setStatusMessage(""), 5000);

    } catch (err) {
      console.error("Error saving transaction:", err);
      setErrorMessage("Something went wrong during upload. Try again.");
    } finally {
        setLoading(false); // ✅ Stop spinner
    }
  };

  return (
    <div style={{ padding: "2rem", background: "#f9f9f9", borderRadius: "8px" }}>
      <h3>Upload Past Transactions</h3>

      {errorMessage && (
        <div style={{ background: "#ffe0e0", padding: "0.5rem", marginBottom: "1rem", borderRadius: "4px", color: "#c00" }}>
          {errorMessage}
          <button onClick={() => setErrorMessage("")} style={{ marginLeft: "1rem" }}>X</button>
        </div>
      )}

      {loading && (
        <div
            style={{
            marginTop: "1rem",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            }}
        >
            <div className="trelli-spinner"></div>
            <p style={{ fontSize: "0.9rem", color: "#555", marginTop: "0.5rem" }}>
            Uploading, please wait...
            </p>
        </div>
        )}

      <input type="file" accept=".csv" onChange={handleFileUpload} />

        {/* ✅ Safe version */}
        {parsedRows.length > 0 && (
        <>
            <h4>Preview ({parsedRows.length} rows)</h4>

            {/* ✅ Fallback account input only when needed */}
            {!Object.keys(parsedRows[0]).some(col => col.toLowerCase().includes("account")) && (
            <div style={{ marginTop: "1rem" }}>
                <label>
                Default Account Name for this upload:{" "}
                <input
                    type="text"
                    placeholder="e.g. Chase 7658 Checking"
                    value={defaultAccount}
                    onChange={(e) => setDefaultAccount(e.target.value)}
                    style={{ marginLeft: "0.5rem" }}
                />
                </label>
            </div>
            )}

            {parsedRows.length > 0 && (
              <div style={{ marginTop: "1rem" }}>
                <label>
                  <input
                    type="checkbox"
                    checked={flipped}
                    onChange={handleFlipAmounts}
                    style={{ marginRight: "0.5rem" }}
                  />
                  Flip all amounts to {flipped ? "original" : "opposite sign"} *Negative is expense, Positive is Income
                </label>
              </div>
            )}

            <div style={{ maxHeight: "200px", overflowY: "auto" }}>
            <table>
                <thead>
                <tr>
                    {Object.keys(parsedRows[0]).map(col => (
                    <th key={col}>{col}</th>
                    ))}
                </tr>
                </thead>
                <tbody>
                {parsedRows.slice(0, 5).map((row, idx) => (
                    <tr key={idx}>
                    {Object.values(row).map((val, i) => (
                        <td key={i}>{val}</td>
                    ))}
                    </tr>
                ))}
                </tbody>
            </table>
            </div>

            <button
            onClick={handleSave}
            style={{
                marginTop: "1rem",
                background: "#00B074",
                color: "#fff",
                padding: "0.5rem 1rem",
                border: "none",
                borderRadius: "4px",
            }}
            >
            Save to My Transactions
            </button>
        </>
        )}
    </div>
  );
}